import {
  ADVERTISING_ADD,
  ADVERTISING_FETCH,
  ADVERTISING_EDIT,
  ADVERTISING_REMOVE,
  ADVERTISING_ERROR
} from "../store/types";
import { firebase } from "../config/configureFirebase";
import { onValue, update, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL, ref, deleteObject } from "firebase/storage";

export const fetchAdvertising = () => async (dispatch) => {
  const { advertisingRef } = firebase;
  try {

    const snapshot = await new Promise((resolve, reject) => {
      onValue(advertisingRef, (snapshot) => {
        resolve(snapshot);
      }, {
        onlyOnce: true
      });
    });

    if (snapshot.exists()) {
      const advertisingData = snapshot.val();

      const advertisingArray = Object.keys(advertisingData).map((key) => ({
        ...advertisingData[key],
        ref: key,
      }));

      advertisingArray.sort((a, b) => b.createdAt - a.createdAt);


      dispatch({
        type: ADVERTISING_FETCH,
        payload: advertisingArray,
      });
    } else {
      throw new Error('Document not found');
    }
  } catch (error) {
    console.error('Error fetching advertising data:', error);
    dispatch({
      type: ADVERTISING_ERROR,
      payload: error.message,
    });
  }
};

export const editAdvertising = (advertising, method, img) => async (dispatch) => {
  const { advertisingAddRef, advertisingEditRef, advertisingImage } = firebase;

  if (method === "Add") {
    const newAdRef = push(advertisingAddRef, advertising);;
    const newAdData = { ...advertising, ref: newAdRef.key };
    dispatch({
      type: ADVERTISING_ADD,
      payload: newAdData,
    });
  }
  else if (method === "Delete") {
    remove(advertisingEditRef(advertising.ref), advertising);

    const imageRef = ref(advertisingImage(advertising.ref));

    await deleteObject(imageRef);

    dispatch({
      type: ADVERTISING_REMOVE,
      payload: advertising,
    });
  }
  else if (method === "Update") {
    update(advertisingEditRef(advertising.ref), advertising);

    dispatch({
      type: ADVERTISING_EDIT,
      payload: advertising,
    });
  }
  else if (method === "UpdateImage") {
    await uploadBytesResumable(advertisingImage(advertising.ref), img);
    let image = await getDownloadURL(advertisingImage(advertising.ref));


    const NewDate = {
      ...advertising,
      tableData: null,
      photoUrl: image
    }

    update(advertisingEditRef(advertising.ref), NewDate);
    dispatch({
      type: ADVERTISING_EDIT,
      payload: NewDate,
    });

  }

};
